var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modal",
      attrs: { title: "Rename linked brief folder", centered: "" },
      on: { hide: _vm.closeHandler },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.$refs.modal.hide()
                    },
                  },
                },
                [_vm._v("\n      Cancel\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "outline-primary" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm("folder_only")
                    },
                  },
                },
                [_vm._v("\n      Just the folder\n    ")]
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  attrs: { variant: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.confirm("both")
                    },
                  },
                },
                [_vm._v("\n      Rename both\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("p", { staticClass: "mb-2" }, [
        _vm._v("\n    This folder is linked to the brief\n    "),
        _c("strong", [_vm._v(_vm._s(_vm.briefTitle))]),
        _vm._v(".\n    Rename the brief too?\n  "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "text-muted small mb-0" }, [
        _vm._v(
          "\n    Choosing “Just the folder” stops automatic syncing. The brief will get a new folder the next time assets are added.\n  "
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }